import { StoreProps } from '@/app/models/store'
import { AnyAction } from 'redux'
import { NewActivityApprovalActions } from '../actions/activity-approval'

export interface ActivitySummaryChartData {
    stores: number
    percentage: number
    color: string
}

export interface NewActivityApprovalState {
    activitySummaryChartData: Record<string, ActivitySummaryChartData>
    selectedStores: StoreProps[]
    approvalStoreList: StoreProps[]
}

export const NEW_ACTIVITY_APPROVAL_REDUCER_NAMESPACE = 'newActivityApprovalReducer'

const defaultState: NewActivityApprovalState = {
    activitySummaryChartData: {},
    selectedStores: [],
    approvalStoreList: []
}

export default (state: NewActivityApprovalState = defaultState, action: AnyAction) => {
    switch (action.type) {
        case NewActivityApprovalActions.SET_SELECTED_STORES:
            return {
                ...state,
                selectedStores: [...action.stores],
            }
        case NewActivityApprovalActions.SET_APPROVAL_STORE_LIST:
            return {
                ...state,
                approvalStoreList: [...action.value],
            }
        case NewActivityApprovalActions.SET_CHART_DATA:
            return {
                ...state,
                activitySummaryChartData: {...action.chartData}
            }
        default:
            return {
                ...state,
            }
    }
}
